import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service'; 
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  msalUserInfo: any;
  userEmail: any;

  constructor(private authService: MsalService, private authUserService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const GUID = 'f4179b26-21ac-432c-bcd8-cb4bc6e50981'
    this.msalUserInfo = this.authService.instance.getActiveAccount() ?.idTokenClaims;
    if(this.msalUserInfo) {
      this.userEmail = this.msalUserInfo && this.msalUserInfo.preferred_username;
    }
    request = request.clone({
      setHeaders:{
        'user-email':this.userEmail
      }
    });
    //request=request.clone({headers:request.headers.set('Accept','application/json')})
    return next.handle(request);
  }
}